import React from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";

const Staffattendance = () => {
  return (
    <>
      <Header />
      <div className="container">
        <section className="top-content-container">
          <div className="my-5 container">
            <div className="row">
              <div className="col-lg-6 p-0">
                <h6 className="headertext">Hariharan - IT</h6>
                <h6 className="subheadertext">Staff</h6>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="row">
            <div className="col-lg-1">
              <Sidebar />
            </div>
            <div className="col-lg-11">
              <div className="graphbox">
                <div className="row">
                  <div className="col-lg-6 p-0">
                    <h6 className="labeltitle">Attendance Overview</h6>
                  </div>
                </div>
                <table className="table table-hover mt-5">
                  <thead>
                    <tr>
                      <th scope="col">Date</th>
                      <th scope="col">Day</th>
                      <th scope="col">Clock-in</th>
                      <th scope="col"></th>
                      <th scope="col">Clock-out</th>
                      <th scope="col">Work hours</th>
                      <th scope="col">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>29 July 2023</td>
                      <td>Monday</td>
                      <td>09:00</td>
                      <td>----</td>
                      <td>18:00</td>
                      <td>10h 2m</td>
                      <td>Present</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Staffattendance;
